import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { jsx } from 'theme-ui';
var browserTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

var getTag = function getTag() {
  var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return browserTags.find(function (b) {
    return b === tag.toLowerCase();
  }) || 'span';
};

var BaseType = function BaseType(tag) {
  return /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var _ref$as = _ref.as,
        as = _ref$as === void 0 ? getTag(tag) : _ref$as,
        props = _objectWithoutProperties(_ref, ["as"]);

    return jsx(as, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref,
      sx: {
        variant: "spark.element.type.".concat(tag)
      }
    }));
  });
};

BaseType.displayName = 'Type';

var createExport = function createExport() {
  var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var Component = BaseType(tag);
  Component.displayName = "Type.".concat(tag);
  return Component;
};

export var H1 = createExport('H1');
export var H2 = createExport('H2');
export var H3 = createExport('H3');
export var H4 = createExport('H4');
export var H5 = createExport('H5');
export var H6 = createExport('H6');
export var S1 = createExport('S1');
export var S2 = createExport('S2');
export var S3 = createExport('S3');
export var Body1 = createExport('Body1');
export var Body2 = createExport('Body2');
export var Body3 = createExport('Body3');
export var Bold1 = createExport('Bold1');
export var Bold2 = createExport('Bold2');
export var Bold3 = createExport('Bold3');
export var Button1 = createExport('Button1');
export var Button2 = createExport('Button2');
export var Button3 = createExport('Button3');
export var Input1 = createExport('Input1');
export var Input2 = createExport('Input2');
export var Input3 = createExport('Input3');
export var Hyperlink1 = createExport('Hyperlink1');
export var Hyperlink2 = createExport('Hyperlink2');
export var Hyperlink3 = createExport('Hyperlink3');
export var Caption = createExport('Caption');
export var Overline = createExport('Overline');
export var Type = {
  H1: H1,
  H2: H2,
  H3: H3,
  H4: H4,
  H5: H5,
  H6: H6,
  S1: S1,
  S2: S2,
  S3: S3,
  Body1: Body1,
  Body2: Body2,
  Body3: Body3,
  Bold1: Bold1,
  Bold2: Bold2,
  Bold3: Bold3,
  Button1: Button1,
  Button2: Button2,
  Button3: Button3,
  Input1: Input1,
  Input2: Input2,
  Input3: Input3,
  Hyperlink1: Hyperlink1,
  Hyperlink2: Hyperlink2,
  Hyperlink3: Hyperlink3,
  Caption: Caption,
  Overline: Overline
};